import React from "react";
import styled from "styled-components";
import { current_season } from "../utils/constants";

const AboutPage = () => {
  return (
    <Canvas>
      <Content>
        <PageTitle>QUIÉNES SOMOS</PageTitle>
        <Body>
          <TextBlock>
            <Paragraph>
              Dark Knight, Birras y Tapas, Clan Templario, NHN, Conquis,
              Forocoches, Chirimoyos, Gentuzas y VN son los clanes fundadores que
              junto con otros que se han ido uniendo posteriormente, componen la
              Comunidad Española de Age of Empires 2.
            </Paragraph>
            <Paragraph>
              Nació como un punto de reunión donde entre todos organizamos torneos
              por y para los miembros de la comunidad, pero con el objetivo de
              recibir con los brazos abiertos a cualquier otro clan u miembro de
              la comunidad española de nuestro amado Age of Empires II.
            </Paragraph>
            <Paragraph>
              Uno de nuestros grandes hitos ha sido lograr la organización de la Liga Española de Age of Empires II, la Clan Wars o el TNE.
            </Paragraph>
            <SignOff>Bienvenidos y 14!</SignOff>
          </TextBlock>
          <LogoBlock>
            <Logo
              src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/cea_logo.png"
              alt="Comunidad Española Age of Empires"
            />
          </LogoBlock>
        </Body>
      </Content>
    </Canvas>
  );
};

const Canvas = styled.div`
  background: var(--v-canvas);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 4rem 1.5rem;
`;

const Content = styled.div`
  width: 100%;
  max-width: 960px;
`;

const PageTitle = styled.h1`
  font-family: Anton, sans-serif;
  font-size: clamp(48px, 8vw, 72px);
  font-weight: 400;
  text-transform: uppercase;
  line-height: 1;
  color: var(--v-fg);
  margin: 0 0 3rem;
`;

const Body = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const Paragraph = styled.p`
  font-family: var(--v-font-body);
  font-size: 15px;
  line-height: 1.8;
  color: var(--v-fg);
  margin: 0;
`;

const SignOff = styled.p`
  font-family: var(--v-font-mono);
  font-size: 14px;
  font-weight: 600;
  color: var(--v-mint);
  margin: 0.5rem 0 0;
`;

const LogoBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 1rem;
`;

const Logo = styled.img`
  width: 100%;
  max-width: 320px;
  object-fit: contain;
`;

export default AboutPage;
